import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsRewardsPricingInfo } from '__generated__/api';

export interface RewardsPricingInfoType {
  title: FlightsRewardsPricingInfo.Title;
  loyaltyBanners: FlightsRewardsPricingInfo.LoyaltyBanners[];
  options: FlightsRewardsPricingInfo.Options[];
  subText: FlightsRewardsPricingInfo.SubText[];
}

export class RewardsPricingInfoStore extends Store {
  @observable public rewardsPricingInfo?: RewardsPricingInfoType;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}

RewardsPricingInfoStore.DEFAULTS = {
  rewardsPricingInfo: null
};
